/* eslint-disable prettier/prettier */
export const getSpan = (x1: number, x2: number) => 1 + (x2 - x1);
